<template>
    <div class="relative">
        <div ref="scrollContainer" class="snap-x flex gap-2 overflow-x-scroll snap-mandatory scrollbar-hide" style="scroll-snap-type: x mandatory;" v-if="items.length > 0">
            <ItemMenuMobile 
                v-for="(item, index) in items" 
                :key="item.name" 
                :item="item" 
                :class="[
                    'snap-start flex-shrink-0',
                    index === 0 ? 'ml-4' : '',
                    index === items.length - 1 ? 'mr-4' : ''
                ]"
                @click="handleClick(item, index)" 
                :is-active="item.id === props.activeTab"
            />
        </div>
        <div v-else class="flex justify-center items-center h-full">
            <div class="text-center text-gray-500 dark:text-gray-400">
                No items to show
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, nextTick, onMounted, computed } from 'vue';
import ItemMenuMobile from './itemMenuMobile.vue';
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
const scrollContainer = ref(null);

const props = defineProps({
    activeTab: {
        type: String,
        required: true
    },
    tabs: {
        type: Array,
        required: true
    }
})
const tabsItems = ref([
    {
        id: 'datasets',
        name: 'Datasets',
        icon: 'uil uil-database',
    },
    {
        id: 'listings',
        name: 'Listings',
        icon: 'uil uil-list-ul',
    },
    {
        id: 'purchases',
        name: 'Purchases',
        icon: 'uil uil-shopping-cart',
    },
    {
        id: 'sales',
        name: 'Sales',
        icon: 'uil uil-money-bill',
    },
    {
        id: 'bids',
        name: 'Bids',
        icon: 'uil uil-arrow-up-right',
    },
    {
        id: 'offers',
        name: 'Offers',
        icon: 'uil uil-tag-alt',
    },
    {
        id: 'rfp',
        name: 'RFPs',
        icon: 'uil uil-clipboard-notes',
    }
])

const items = computed(() => {
    const result = [];
    props.tabs.forEach(tab => {
        const item = tabsItems.value.find(item => item.id === tab.id);
        if (item) {
            result.push(item);
        }
    });
    return result;
});

const emit = defineEmits(['handle-click']);

const centerItem = async (index) => {
    await nextTick();
    
    if (!scrollContainer.value) return;
    
    const container = scrollContainer.value;
    const itemWidth = 96;
    const gap = 8;
    const containerWidth = container.clientWidth;
    
    const itemPosition = index * (itemWidth + gap) + (index === 0 ? 16 : 0);
    
    const scrollTo = itemPosition - (containerWidth / 2) + (itemWidth / 2);
    
    container.scrollTo({
        left: Math.max(0, scrollTo),
        behavior: 'smooth'
    });
};

const scrollToTopIfNeeded = async () => {
    await nextTick();
    
    if (!scrollContainer.value) return;
    
    const containerRect = scrollContainer.value.getBoundingClientRect();
    const isNearTop = containerRect.top <= 20;
    
    if (!isNearTop) {
        const scrollTop = window.pageYOffset + containerRect.top - 20;
        
        window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
        });
    }
};

const handleClick = async (item, index) => {
    emit('handle-click', item);
    await centerItem(index);
    await scrollToTopIfNeeded();
    router.push({ query: { tab: item.id } });
}

onMounted(() => {
    const tab = route.query.tab;
    if (tab) {
        handleClick(items.value.find(item => item.id === tab), items.value.findIndex(item => item.id === tab));
    }
})
</script>

<style scoped>
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}
</style>